const messages = {
  title: "Preislisten und Produktbroschüren",
  title_media: "Preislisten und Produktbroschüren",
  description:
    "In unserer Medienbibliothek stehen Ihnen eine Vielzahl von Medien unserer Marken Bridgestone und Firestone sowie weiteren Reifenlösungen zur Verfügung. Nutzen Sie verschiedene Filteroptionen oder geben Sie gezielte Suchanfragen in das Suchfeld ein, um Ihre gewünschten Medien schnell zu finden",
  short_description:
    "Hier finden Sie Inhalte für Social Media, Instore-TV und mehr.",
  mediaCategories: {
    products: "Produkte",
    brand_and_solutions: "Marke & Lösungen",
    season_and_promotions: "Saison & Aktionen",
    format: "Format",
    cars_and_vans: "Pkw & Transporter",
    truck_and_buses: "Lkw & Bus",
    motorcycle: "Motorradrrad",
    agriculture: "Landwirtschaft",
    construction_machinery: "Baumaschinen",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materialien",
    brochures: "Produktbroschüren",
    price_list: "Preislisten",
    materials: "Materialien",
    video_in_store: "Video (Instore)",
    video_online: "Video (Online)",
    video: "Video",
    banner_website: "Banner (Webseite)",
    banner_social_media: "Banner (Social Media)",
    logos: "Logos",
    summer: "Sommer",
    winter: "Winter",
    all_season: "All Season",
    promotions: "Aktionen",
    price: "Pricat",
  },
  buttons: {
    media: "ENTDECKEN",
  },
  searchMedia: "Suchbegriff eingeben",
  searchResults: "Suchergebnisse",
};

export default {
  messages,
};
